// removed by extract-text-webpack-plugin
module.exports = {"Base":"Ad__Base-3oviM","Base--4x3":"Ad__Base--4x3-2h9CK Ad__Base-3oviM","Base--4x4":"Ad__Base--4x4-hn2wp Ad__Base-3oviM","Base--8x1":"Ad__Base--8x1-3SSg1 Ad__Base-3oviM","Base--16x9":"Ad__Base--16x9-2taB3 Ad__Base-3oviM","AdLink":"Ad__AdLink-3u9Qe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Ad/Ad.css
 ** module id = 621
 ** module chunks = 0
 **/